'use strict';

exports.__esModule = true;
exports.authHeader = authHeader;

var _ApiRest = require('../api/ApiRest');

function authHeader() {
  var header = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var identificadorSesion = JSON.parse(_ApiRest.ApiRest.obtenerDatoLocal('tokenSeps'));

  if (identificadorSesion) {
    header['Authorization'] = 'Bearer ' + identificadorSesion;
  }

  return header;
}